import { IconButton, Tooltip } from '@mui/material'
import { isEqual } from 'lodash'
import { memo, useCallback, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack, MdDelete } from 'react-icons/md'
import { metodoPrograma } from '../../../../components/api'
import Table from '../../../../components/Table'
import Edicao from './Edicao'

const TipoDeUsuario = ({
  linhaSelecionada,
  voltar,
  tela,
  setTela,
  ferramentas,
  setFerramentas,
}) => {
  const [listaContratante, setListaContratante] = useState([])
  const [linhaTipoSelecionada, setLinhaTipoSelecionada] = useState([])
  const [telaInterna, setTelaInterna] = useState([])

  const buscaLista = useCallback(async () => {
    const dados = { idContratante: linhaSelecionada[0] }
    const res = await metodoPrograma('listaTiposUsuariosContratante', dados)
    setListaContratante(res.lista || [])
  }, [linhaSelecionada])

  const voltarInterno = () => {
    buscaLista()
    setTelaInterna('listaTipoDeUsuario')
  }

  useEffect(() => {
    setTelaInterna('listaTipoDeUsuario')
    buscaLista()
  }, [buscaLista])

  const exclui = (idUsuario) => async (e) => {
    e.stopPropagation()
    if (
      !window.confirm('Mas você tem CERTEZA que deseja excluir este usuário???')
    )
      return
    await metodoPrograma('exclui', { idUsuario })
    await buscaLista()
  }

  useEffect(() => {
    switch (telaInterna) {
      case 'listaTipoDeUsuario':
        setFerramentas(
          <>
            <Tooltip title="Voltar">
              <IconButton onClick={voltar}>
                <MdArrowBack />
              </IconButton>
            </Tooltip>
            <Tooltip title="Adicionar Adicionar Tipo de Usuário">
              <IconButton onClick={() => setTelaInterna('opcoesTipoDeUsuario')}>
                <MdAdd />
              </IconButton>
            </Tooltip>
          </>,
        )
        break
      case 'opcoesTipoDeUsuario':
        setFerramentas(
          <>
            <Tooltip title="Voltar">
              <IconButton onClick={voltarInterno}>
                <MdArrowBack />
              </IconButton>
            </Tooltip>
          </>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [telaInterna])

  const handleClick = async (_, linha) => {
    setLinhaTipoSelecionada(linha)
    setTelaInterna('opcoesTipoDeUsuario')
  }
  return (
    <>
      {telaInterna === 'listaTipoDeUsuario' ? (
        <>
          <h4>
            {linhaSelecionada[1]} - <small>Tipo de Usuário</small>
          </h4>
          <Table
            dados={listaContratante}
            head={['ID', 'Descrição', 'Inclusão', 'Exclusão', '']}
            line={(l) => [l[0], l[2], l[3], l[4], '']}
            columnOptions={[
              {
                alias: 4,
                customJsx: ({ itemFormatado, linhaOriginal }) =>
                  linhaOriginal[4] ? (
                    ''
                  ) : (
                    <IconButton size="small" onClick={exclui(itemFormatado)}>
                      <MdDelete />
                    </IconButton>
                  ),
              },
            ]}
            onClick={handleClick}
          />
        </>
      ) : (
        <Edicao
          {...{
            linhaTipoSelecionada,
            voltar,
            linhaSelecionada,
            tela,
            setTela,
            telaInterna,
            setTelaInterna,
            ferramentas,
            setFerramentas,
            voltarInterno,
          }}
        />
      )}
    </>
  )
}

export default memo(TipoDeUsuario, isEqual)
